import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MyPromise } from '../interceptors/myPromise.service';
import * as FileSaver from 'file-saver';

const URL = `${environment.baseEndpointPHP}/sasisopa`;
const URLSASISOPA = `${environment.baseEndpointPHP}`;

@Injectable({ providedIn: 'root' })
export class SasisopaService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }
  // NEW procedures
  getInfoProcedureNew(stationId: string, key: string, year: string | number) {
    return this.myPromise.to(this.http.get(`${URL}/procedures/station/${stationId}/key/${key}/year/${year}`));
  }
  storeInfoProcedureNew(stationId: string, data) {
    return this.myPromise.to(this.http.post(`${URL}/procedures/station/${stationId}/new`, data));
  }
  updateInfoProcedureNew(id: string, data) {
    return this.myPromise.to(this.http.put(`${URL}/procedures/${id}/new`, data));
  }
  removeInfoProcedureNew(id: string) {
    return this.myPromise.to(this.http.delete(`${URL}/procedures/${id}/new`));
  }
  // END NEW procedures


  getProcedures(stationId: string) {
    return this.myPromise.to(this.http.get(`${URL}/procedures/station/${stationId}`));
  }

  updateStationProcedure (stationId: string, data: { sasisopa_procedure_id: number; code: string; name: string }) {
    return this.myPromise.to(this.http.post(`${URL}/procedures/station/${stationId}`, data));
  }

  getDocumentsByStationIdAndProcedureId (stationId: string, procedureId: any) {
    return this.myPromise.to(this.http.get(`${URL}/procedures/${procedureId}/station/${stationId}`));
  }

  getDetailsByStationDocumentId (stationId: string, procedureId: any, documentId: number) {
    return this.myPromise.to(this.http.get(`${URL}/procedures/${procedureId}/station/${stationId}/document/${documentId}/details`));
  }

  storeDocument (stationId: string, procedureId: any, data: { code: string; name: string }) {
    return this.myPromise.to(this.http.post(`${URL}/procedures/${procedureId}/station/${stationId}/document`, data));
  }

  storeDocumentDetail (stationId: string, documentId: number, data: { code: string; name: string; date: string; id_responsable: string; type: string; }) {
    return this.myPromise.to(this.http.post(`${URL}/station/${stationId}/document/${documentId}/detail`, data));
  }

  updateDocument (id: number, data: { code: string; name: string }) {
    return this.myPromise.to(this.http.put(`${URL}/documents/${id}`, data));
  }

  updateDetail (id: number, data: { code: string; name: string; date: string; id_responsable: string; type: string; }) {
    return this.myPromise.to(this.http.put(`${URL}/document/detail/${id}`, data));
  }

  deleteDocument (id: number) {
    return this.myPromise.to(this.http.delete(`${URL}/documents/${id}`));
  }

  deleteDocumentDetail (id: number) {
    return this.myPromise.to(this.http.delete(`${URL}/document/detail/${id}`));
  }

  uploadImage (stationId: string, data: { type: any; type_id: any; urls: Array<string>; }) {
    return this.myPromise.to(this.http.post(`${URL}/documents/station/${stationId}`, data));
  }

  deleteAttached (id: number) {
    return this.myPromise.to(this.http.delete(`${URL}/attached/${id}`));
  }

  createTarget (data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/goals`, data));
  }

  getTargets(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/goals/${stationId}/${year}`));
  }

  editTarget(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/goals/${targetId}`, data));
  }

  deleteTarget(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/goals/${targetId}`));
  }

  createPolitic (data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/politics`, data));
  }

  getPolitics(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/politics/${stationId}/${year}`));
  }

  editPolitic(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/politics/${targetId}`, data));
  }

  deletePolitic(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/politics/${targetId}`));
  }

  createTechnicalRepresentative(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/technical_leaders`, data));
  }

  getTechnicalRepresentatives(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/technical_leaders/${stationId}/${year}`));
  }

  editTechnicalRepresentative(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/technical_leaders/${targetId}`, data));
  }

  deleteTechnicalRepresentative(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/technical_leaders/${targetId}`));
  }

  createResources(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/resources`, data));
  }

  getResources(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/resources/${stationId}/${year}`));
  }

  editResources(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/resources/${targetId}`, data));
  }

  deleteResources(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/resources/${targetId}`));
  }

  createTrainingNeeds(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/training-needs`, data));
  }

  getTrainingNeeds(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/training-needs/${stationId}/${year}`));
  }

  editTrainingNeeds(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/training-needs/${targetId}`, data));
  }

  deleteTrainingNeeds(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/training-needs/${targetId}`));
  }

  createTrainingLists(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/training-lists`, data));
  }

  getTrainingLists(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/training-lists/${stationId}/${year}`));
  }

  editTrainingLists(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/training-lists/${targetId}`, data));
  }

  deleteTrainingLists(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/training-lists/${targetId}`));
  }

  createJobProfile(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/profile-roles`, data));
  }

  getJobProfile(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/profile-roles/${stationId}/${year}`));
  }

  editJobProfile(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/profile-roles/${targetId}`, data));
  }

  deleteJobProfile(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/profile-roles/${targetId}`));
  }

  createCompetencies(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/capabilities`, data));
  }

  getCompetencies(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/capabilities/${stationId}/${year}`));
  }

  editCompetencies(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/capabilities/${targetId}`, data));
  }

  deleteCompetencies(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/capabilities/${targetId}`));
  }

  createCommunications(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/communication-patterns`, data));
  }

  getCommunications(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/communication-patterns/${stationId}/${year}`));
  }

  editCommunications(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/communication-patterns/${targetId}`, data));
  }

  deleteCommunications(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/communication-patterns/${targetId}`));
  }

  createInsecureConditions(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/insecure-conditions`, data));
  }

  getInsecureConditions(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/insecure-conditions/${stationId}/${year}`));
  }

  editInsecureConditions(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/insecure-conditions/${targetId}`, data));
  }

  deleteInsecureConditions(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/insecure-conditions/${targetId}`));
  }

  createConfidentialityAgreement(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/confidentiality-agreement`, data));
  }

  getConfidentialityAgreement(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/confidentiality-agreement/${stationId}/${year}`));
  }

  editConfidentialityAgreement(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/confidentiality-agreement/${targetId}`, data));
  }

  deleteConfidentialityAgreement(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/confidentiality-agreement/${targetId}`));
  }

  createFollowService(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/follow-service`, data));
  }

  getFollowService(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/follow-service/${stationId}/${year}`));
  }

  editFollowService(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/follow-service/${targetId}`, data));
  }

  deleteFollowService(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/follow-service/${targetId}`));
  }

  createResponsiveLetter(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/responsive-letter`, data));
  }

  getResponsiveLetter(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/responsive-letter/${stationId}/${year}`));
  }

  editResponsiveLetter(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/responsive-letter/${targetId}`, data));
  }

  deleteResponsiveLetter(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/responsive-letter/${targetId}`));
  }

  createReportRequests(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/report-requests`, data));
  }

  getReportRequests(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/report-requests/${stationId}/${year}`));
  }

  editReportRequests(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/report-requests/${targetId}`, data));
  }

  deleteReportRequests(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/report-requests/${targetId}`));
  }

  createReports(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/reports`, data));
  }

  getReports(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/reports/${stationId}/${year}`));
  }

  editReports(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/reports/${targetId}`, data));
  }

  deleteReports(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/reports/${targetId}`));
  }

  createAssistanceCommunication(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/assistance-communication`, data));
  }

  getAssistanceCommunication(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/assistance-communication/${stationId}/${year}`));
  }

  editAssistanceCommunication(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/assistance-communication/${targetId}`, data));
  }

  deleteAssistanceCommunication(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/assistance-communication/${targetId}`));
  }

  createStandards(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/standards`, data));
  }

  getStandards(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/standards/${stationId}/${year}`));
  }

  editStandards(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/standards/${targetId}`, data));
  }

  deleteStandards(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/standards/${targetId}`));
  }

  createProcesses(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/processes`, data));
  }

  getProcesses(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/processes/${stationId}/${year}`));
  }

  editProcesses(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/processes/${targetId}`, data));
  }

  deleteProcesses(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/processes/${targetId}`));
  }

  createContractor(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/contractors`, data));
  }

  getContractor(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/contractors/${stationId}/${year}`));
  }

  editContractor(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/contractors/${targetId}`, data));
  }

  deleteContractor(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/contractors/${targetId}`));
  }

  getEmergencyPlannings(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/identified-risk-situation/${stationId}/${year}`));
  }

  deleteEmergencyPlanning(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/identified-risk-situation/${targetId}`));
  }

  createEmergencyPlanning(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/identified-risk-situation`, data));
  }

  editEmergencyPlanning(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/identified-risk-situation/${targetId}`, data));
  }

  getEmergencyContacts(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/emergency-contacts/${stationId}/${year}`));
  }

  deleteEmergencyContact(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/emergency-contacts/${targetId}`));
  }

  createEmergencyContact(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/emergency-contacts`, data));
  }

  editEmergencyContact(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/emergency-contacts/${targetId}`, data));
  }

  getBrigades(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/brigades/${stationId}/${year}`));
  }

  deleteBrigade(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/brigades/${targetId}`));
  }

  createBrigade(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/brigades`, data));
  }

  editBrigade(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/brigades/${targetId}`, data));
  }

  getResourceAvailabilities(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/resource-availability/${stationId}/${year}`));
  }

  deleteResourceAvailability(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/resource-availability/${targetId}`));
  }

  createResourceAvailability(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/resource-availability`, data));
  }

  editResourceAvailability(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/resource-availability/${targetId}`, data));
  }

  getReportsResult(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/reports-result/${stationId}/${year}`));
  }

  deleteReportsResult(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/reports-result/${targetId}`));
  }

  createReportsResult(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/reports-result`, data));
  }

  editReportsResult(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/reports-result/${targetId}`, data));
  }

  getFindingsManager(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/findings/${stationId}/${year}`));
  }

  deleteFindingsManager(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/findings/${targetId}`));
  }

  createFindingsManager(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/findings`, data));
  }

  editFindingsManager(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/findings/${targetId}`, data));
  }

  getInvestigationActivitiesProgram(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/investigation-activities-program/${stationId}/${year}`));
  }

  deleteInvestigationActivitiesProgram(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/investigation-activities-program/${targetId}`));
  }

  createInvestigationActivitiesProgram(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/investigation-activities-program`, data));
  }

  editInvestigationActivitiesProgram(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/investigation-activities-program/${targetId}`, data));
  }

  getReviewResults(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/review-results/${stationId}/${year}`));
  }

  deleteReviewResults(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/review-results/${targetId}`));
  }

  createReviewResults(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/review-results`, data));
  }

  editReviewResults(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/review-results/${targetId}`, data));
  }

  getAuditProgram(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/audit-program/${stationId}/${year}`));
  }

  deleteAuditProgram(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/audit-program/${targetId}`));
  }

  createAuditProgram(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/audit-program`, data));
  }

  editAuditProgram(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/audit-program/${targetId}`, data));
  }

  getAuditPlan(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/audit-plan/${stationId}/${year}`));
  }

  deleteAuditPlan(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/audit-plan/${targetId}`));
  }

  createAuditPlan(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/audit-plan`, data));
  }

  editAuditPlan(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/audit-plan/${targetId}`, data));
  }

  getAuditReport(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/audit-report/${stationId}/${year}`));
  }

  deleteAuditReport(targetId: string) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/audit-report/${targetId}`));
  }

  createAuditReport(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/audit-report`, data));
  }

  editAuditReport(targetId: string, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/audit-report/${targetId}`, data));
  }

  downloadSasisopaFormat({stationId, procedure, format, fileType = 'docx', modelId, year}: { stationId: string, procedure: string, format: string, fileType?: string, modelId?: string, year?: number | string }) {
    return new Promise(resolve => {
      const url = modelId
        ? `${URLSASISOPA}/sasisopa-resources/${stationId}/${procedure}/${format}?model_id=${modelId}&year=${year}`
        : `${URLSASISOPA}/sasisopa-resources/${stationId}/${procedure}/${format}?year=${year}`;
      this.http.get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/octet-stream',
        }), responseType: 'blob' as 'json', observe: 'response' as 'body',
      }).subscribe((response: any) => {
        const blob = new Blob([response.body]);
        FileSaver.saveAs(blob, `p${procedure}_${format}.${fileType}`);
        resolve(true);
      });
    });
  }

  async getCriticalEquipment(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/critical-equipment/${stationId}/${year}`));
  }

  async createCriticalEquipment(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/critical-equipment`, data));
  }

  async editCriticalEquipment(id, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/critical-equipment/${id}`, data));
  }

  async deleteCriticalEquipment(itemId: any) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/critical-equipment/${itemId}`));
  }

  async createChangesControl(data: any) {
    return this.myPromise.to(this.http.post(`${URLSASISOPA}/control-changes`, data));
  }

  async editChangesControl(id, data: any) {
    return this.myPromise.to(this.http.put(`${URLSASISOPA}/control-changes/${id}`, data));
  }

  async getChangesControl(stationId: string, year: string) {
    return this.myPromise.to(this.http.get(`${URLSASISOPA}/control-changes/${stationId}/${year}`));
  }

  async deleteChangesControl(itemId: any) {
    return this.myPromise.to(this.http.delete(`${URLSASISOPA}/control-changes/${itemId}`));
  }
}
